import { coerceValue } from '@/helper/utils';

export function resolveRecommendationLoggedInView({
  hasCustomerContext,
  loggedIn,
  simulateLoggedIn,
  isStoryblokEditor,
}: {
  hasCustomerContext: boolean;
  loggedIn: boolean;
  simulateLoggedIn?: unknown;
  isStoryblokEditor: boolean;
}): boolean {
  if (!hasCustomerContext) return false;

  if (isStoryblokEditor) {
    return coerceValue(simulateLoggedIn) === true;
  }

  return loggedIn;
}
